<script lang="ts">
    import {_} from 'svelte-i18n'
    import type {Conversation, Session} from './types';
    import {Role} from './types';
    import Tooltip, {Title, Wrapper} from '@smui/tooltip';
    import List, {Item, PrimaryText, SecondaryText, Text} from '@smui/list';
    import IconButton from '@smui/icon-button';
    import Button, {Label} from '@smui/button';
    import {
        activeConversations,
        activeOperatorsAndIntervisors,
        conversationRemoteRepository,
        myActiveConversation,
        mySession,
        paths,
        walker
    } from './services';
    import {getAssignedActiveConversations, hasAnyRole, isOfSession} from './service/util';
    import OperatorName from './OperatorName.svelte';
    import SessionRoles from './SessionRoles.svelte';
    import OperatorWastingTime from './OperatorState.svelte';
    import {get} from 'svelte/store';

    async function reassignConversation(conversation: Conversation, targetSession: Session) {
		await conversationRemoteRepository.reassignConversation(conversation, targetSession);
		await walker.goTo(get(paths).home);
	}
</script>


{#if hasAnyRole($mySession, Role.OPERATOR, Role.INTERVISOR, Role.ADMIN) && ($activeOperatorsAndIntervisors.length > 1 || ($activeOperatorsAndIntervisors.length === 1 && $activeOperatorsAndIntervisors[0].id !== $mySession.id))}
	<Wrapper rich>
		<IconButton class="material-icons">
			{#if $activeOperatorsAndIntervisors.filter(session => session.id !== $mySession.id).flatMap(session => session.roles).includes(Role.INTERVISOR)}
				visibility
			{:else}
				groups
			{/if}
		</IconButton>
		<Tooltip xPos="start" persistent style="width: 380px;">
			<Title>{$_('user.session.LoggedEmployees')}</Title>
			<List nonInteractive twoLine style="text-align: left; width: 100%;">
				{#each $activeOperatorsAndIntervisors as activeSession}
					<Item style="display: flex; flex-direction: row; justify-content: space-between;">
						<div>
							<Text>
								<PrimaryText><OperatorName session={activeSession} /></PrimaryText>
								<SecondaryText>
									<SessionRoles session={activeSession} />
									{#if hasAnyRole($mySession, Role.INTERVISOR, Role.ADMIN)}
										<span style="font-size: 0.7em;"><OperatorWastingTime session={activeSession}>| </OperatorWastingTime></span>
									{/if}
								</SecondaryText>
							</Text>
						</div>
						{#if $myActiveConversation && !isOfSession($myActiveConversation, activeSession) && activeSession.roles.includes(Role.OPERATOR) && getAssignedActiveConversations(activeSession, $activeConversations).length === 0}
							<div>
								<Button type="button" on:click={() => reassignConversation($myActiveConversation, activeSession)} style="font-size: 0.6em;">
									<Label>{$_('chat.HandoverChat')}</Label>
								</Button>
							</div>
						{/if}
					</Item>
				{/each}
			</List>
		</Tooltip>
	</Wrapper>
{/if}